import { CredentialsManagerGridController } from '../controller/CredentialsManagerGridController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { Observable } from 'rxjs';
import { CredentialsManagerFormValue } from '../types';

export class CredentialsManagerGridWebComponent extends BaseWebComponentElement {
  public controller!: CredentialsManagerGridController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CredentialsManagerGridController,
    });
  }

  public get value(): CredentialsManagerFormValue {
    return {
      credentials: this.controller.selectedItems,
    };
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }
}
